module.exports = __webpack_public_path__ + "assets/7d8af300f30237af65fb81a6ba58aa30.svg";